export const demoDashboard = {
  organizationName: "Metro Darts Association",
  leagueName: "Metro Dart League",
  profile: {
    firstName: "Demo",
    lastName: "Player",
    email: "demo@ocheleague.com",
    phone: "",
    membershipDisplayId: "OCHE-1042",
    status: "Active",
  },
  teams: [
    {
      registrationId: "demo-team",
      teamName: "The Board Members",
      leagueName: "Metro Dart League",
      seasonName: "Fall 2026",
      nightName: "Monday A Night",
      weekday: "Monday",
      homePub: "The Brass Tap",
      isCaptain: true,
      captainName: "Demo Player",
    },
  ],
  matches: [
    {
      matchId: "demo-match",
      matchDate: new Date(Date.now() + 86400000 * 3).toISOString().slice(0, 10),
      roundNumber: 4,
      isHome: true,
      opponentName: "Triple Trouble",
      pubName: "The Brass Tap",
      isBye: false,
      teamName: "The Board Members",
      leagueName: "Metro Dart League",
      seasonName: "Fall 2026",
      divisionName: "Division A",
      nightName: "Monday A Night",
      seasonSnapshot: {
        playerMatchesPlayed: 4,
        playerGamesPlayed: 12,
        teamMatchesPlayed: 4,
        teamWins: 3,
        teamLosses: 1,
        teamTies: 0,
        teamWinPercentage: 75,
        teamStanding: 3,
        teamCount: 10,
        qualityPoints: 5,
        qualityPointRank: 2,
        cricketMarks: 21,
        cricketMarksRank: 4,
        rankedPlayerCount: 48,
        qualityPointLeaders: [
          { playerMembershipId: "demo-player", rank: 2, playerName: "Demo Player", teamName: "The Board Members", total: 5, isCurrentPlayer: true },
        ],
        cricketMarkLeaders: [
          { playerMembershipId: "demo-player", rank: 4, playerName: "Demo Player", teamName: "The Board Members", total: 21, isCurrentPlayer: true },
        ],
      },
    },
  ],
  statistics: {
    gamesPlayed: 28,
    wins: 18,
    losses: 10,
    qualityPoints: 12,
    bestOut: 96,
    winPercentage: 64.3,
  },
  fees: [
    {
      id: "demo-fee",
      description: "Annual membership",
      coverageLabel: "2026",
      amount: 30,
      paid: 30,
      balance: 0,
      status: "Paid",
    },
  ],
  recentResults: [
    {
      id: "demo-result",
      status: "Final",
      recordedAt: new Date().toISOString(),
      summary: "7–4",
    },
  ],
};
